export default {
  TIME_REGISTRATION_JAKON_PROJECT: "TIME_REGISTRATION_JAKON_PROJECT",
  TIME_REGISTRATION_HOURS: "TIME_REGISTRATION_HOURS",
};
